import React, { useState } from "react";
import styled from "styled-components";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import { logotext, socialprofils } from "../content_option";
import Themetoggle from "../components/themetoggle";

const SiteHeader = styled.header`
  top: 10px;
  padding-left: 10px;
  padding-right: 10px;
`;

const MenuButton = styled.div`
  cursor: pointer;
  color: var(--text-color);
  margin-left: 10px;
  margin-right: 10px;

  svg {
    width: 2em;
    height: 2em;
    fill: var(--text-color-2);
    color: var(--text-color-2);
  }
`;

const NavAc = styled(Link)`
  padding: 5px 15px;
  margin: 0;
  border: unset;
  background: transparent;
  font-size: 1.25rem;
  font-family: Marcellus;
  color: var(--text-color-2);
  line-height: 2;
  height: 50px;
  font-weight: bold;
  z-index: 1000;

  &:hover {
    color: var(--text-color-2);
  }
`;

const NavAcButton = styled.button`
  padding: 5px 15px;
  margin: 0;
  border: unset;
  background: transparent;
  font-size: 1.25rem;
  font-family: Marcellus;
  color: var(--text-color-2);
  line-height: 2;
  height: 50px;
  font-weight: bold;
  z-index: 1000;

  &:hover {
    color: var(--text-color-2);
  }
`;

const BorderTop = styled.div`
  position: fixed;
  z-index: 999999;
  background: var(--primary-color);
  top: 0;
  height: 10px;
  left: 0;
  width: 100%;
`;

const BorderBottom = styled.div`
  position: fixed;
  z-index: 999999;
  background: var(--primary-color);
  bottom: 0;
  left: 0;
  height: 10px;
  width: 100%;
`;

const BorderRight = styled.div`
  position: fixed;
  z-index: 999999;
  background: var(--primary-color);
  width: 10px;
  right: 0;
  top: 0;
  height: 100%;
`;

const BorderLeft = styled.div`
  position: fixed;
  z-index: 999999;
  background: var(--primary-color);
  width: 10px;
  left: 0;
  top: 0;
  height: 100%;
`;

const SiteNavigation = styled.div`
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
`;

const BgMenu = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: var(--primary-color);
  will-change: transform;
  transform: ${props => props.isOpen ? 'translateY(0)' : 'translateY(-100%)'};
  transition: 0.5s ease all;
`;

const MenuWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden auto;
`;

const MenuContainer = styled.div`
  @media (min-width: 992px) {
    margin-left: 33.3333%;
  }
`;

const TheMenu = styled.ul`
  padding-top: 20vh;
  padding-bottom: 20vh;
  padding-left: 0;

  @media (min-width: 992px) {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
`;

const MenuItem = styled.li`
  list-style: none;
  margin: 10px 0;
`;

const MenuLink = styled(Link)`
  color: var(--text-color-2);
  line-height: 1;
  font-size: 2rem;
  display: inline-block;
  position: relative;
  transition: color 250ms cubic-bezier(0, 0, 0.58, 1) 0s;
  padding: 4px 0px;
  text-decoration: none;
  font-family: Marcellus;

  &:hover {
    color: var(--text-color-3);
  }

  @media (min-width: 768px) {
    font-size: 4.8vw;
  }
`;

const MenuFooter = styled.div`
  bottom: 0;
  font-family: Marcellus;
  font-size: 14px;
  background: var(--primary-color);

  a {
    color: var(--text-color-2);
    margin-right: 10px;
    text-decoration: none;
  }
`;

const Headermain = () => {
  const location = useLocation(); // Get location object
  const [isActive, setActive] = useState("false");

  const handleToggle = () => {
    setActive(!isActive);
    document.body.classList.toggle("ovhidden");
  };

  return (
    <>
      <SiteHeader className="fixed-top">
        <div className="d-flex align-items-center justify-content-between">
          <NavAc
            to="/"
            className="navbar-brand"
            onClick={(event) => {
              if(location.pathname === '/'){
                event.preventDefault();
                return;
              }
            }}
          >
            {logotext}
          </NavAc>

          <div className="d-flex align-items-center" style={{ gap: '15px' }}>
            {location.pathname !== '/resume' && <Themetoggle />}
            <MenuButton onClick={handleToggle}>
              {!isActive ? <VscClose /> : <VscGrabber />}
            </MenuButton>
          </div>
        </div>

        <SiteNavigation isOpen={!isActive}>
          <BgMenu className="h-100" isOpen={!isActive}>
            <MenuWrapper>
              <MenuContainer className="p-3">
                <TheMenu>
                  <MenuItem>
                    <MenuLink onClick={handleToggle} to="/" className="my-3">
                      Home
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink onClick={handleToggle} to="/portfolio" className="my-3">
                      Portfolio
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink onClick={handleToggle} to="/about" className="my-3">
                      About
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink onClick={handleToggle} to="/contact" className="my-3">
                      Contact
                    </MenuLink>
                  </MenuItem>
                  <MenuItem>
                    <MenuLink onClick={handleToggle} to="/resume" className="my-3">
                      Resume
                    </MenuLink>
                  </MenuItem>
                </TheMenu>
              </MenuContainer>
            </MenuWrapper>
          </BgMenu>
          <MenuFooter className="d-flex flex-column flex-md-row justify-content-between align-items-md-center position-absolute w-100 p-3">
            <div className="d-flex">
              {socialprofils.facebook && (
                <a href={socialprofils.facebook}>Facebook</a>
              )}
              <a href={socialprofils.github}>Github</a>
              <a href={socialprofils.twitter}>Twitter</a>
              <a href={socialprofils.sketchfab}>Sketchfab</a>
              <a href='https://v1.sonnycirasuolo.com'> -- v1</a>
            </div>
            <p className="copyright m-0">copyright __ {logotext}</p>
          </MenuFooter>
        </SiteNavigation>
      </SiteHeader>
      <BorderTop />
      <BorderBottom />
      <BorderLeft />
      <BorderRight />
    </>
  );
};

export default Headermain;
